// extracted by mini-css-extract-plugin
export var fullHeightState = "_4l-7";
export var headerCell = "_4l-1";
export var loadingStateCell = "_4l-4";
export var rowWrapper = "_4l-3";
export var standaloneTable = "_4l-8";
export var standaloneTableWithBodyFill = "_4l-9";
export var stateCell = "_4l-5";
export var table = "_4l-0";
export var tableBodyFiller = "_4l-6";
export var white = "_4l-2";